import Lenis from "lenis";
import gsap from "gsap";
import { Roadmap } from "./roadmap";
import { Header } from "./header";

/**
 * Initialize the application
 */
export function initializeApp(): void {
  // Add your initialization logic here
  /** Smooth scroler */
  const lenis = new Lenis();

  gsap.ticker.add((ts) => {
    lenis.raf(ts * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  // Initialize header
  const header = document.querySelector<HTMLElement>(".header");
  if (header) new Header(header);

  // Initialize roadmap components
  const roadmaps = document.querySelectorAll<HTMLElement>(
    '[data-module="roadmap"]'
  );
  roadmaps.forEach((roadmap) => new Roadmap(roadmap));
}
